import FileUploadState from 'redux/fileUpload/types/fileUploadState';
import { FileUploadActionTypes } from 'redux/fileUpload/fileUploadActions';

const isAutostartState = (state: FileUploadState) =>
  state.status === FileUploadActionTypes.PREPARING && state.autostart;

export default isAutostartState;
